import React from "react";

const TabsContent = ({ tabs, activeTab }) => {
  return (
    <div className="tab-content mt-3">
      {tabs.map((tab, index) => (
        <div
          key={index}
          className={`tab-pane fade ${
            activeTab === index ? "show active" : ""
          }`}
        >
          {tab.content}
        </div>
      ))}
    </div>
  );
};

export default TabsContent;
